import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useMyProjectAsk = (page: string, userid: string) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [askList, setAskList] = useState<ProjectAskListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();
  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.mypage.b2b5, [location.search, userid, page]],
    () =>
      fetcher.mypage.postProjectAskList1({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        pm2: String(userid),  
        group: String(page),  
      }),
    {
      enabled: (page === 'b2b5'), 
      onSuccess: (res: ProjectAskListResDto) => {
        switch (res.code) {
          case 200:
            setAskList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { askList, searchResult, refetch };
};

export default useMyProjectAsk;
